import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import type { Dayjs } from "dayjs";
import type { FC } from "react";
import dayjs, { ISO_DATE_FORMAT, LOCALE } from "../../dayjs";

interface Props {
  readonly value: Dayjs | null;
  readonly onChange: (month: Dayjs | null) => void;
}

const MonthPicker: FC<Props> = ({ value, onChange }) => (
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={LOCALE}>
    <DatePicker
      label="Miesiąc rozpoczęcia"
      views={["month", "year"]}
      minDate={dayjs("2016-01-01", ISO_DATE_FORMAT)}
      maxDate={dayjs().add(3, "years")}
      value={value}
      slotProps={{
        textField: { fullWidth: true },
      }}
      onChange={onChange}
    />
  </LocalizationProvider>
);

export default MonthPicker;
